import { render, staticRenderFns } from "./AddTextV3.vue?vue&type=template&id=f67fa842"
import script from "./AddTextV3.vue?vue&type=script&lang=js"
export * from "./AddTextV3.vue?vue&type=script&lang=js"
import style0 from "./AddTextV3.vue?vue&type=style&index=0&id=f67fa842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports